export const THEME_NAME_OPTIONS = [
  { value: "fame", label: "Fame" },
  { value: "genie", label: "Genie" },
  { value: "king", label: "King" },
//   { value: "master", label: "Master" },
  { value: "metro", label: "Metro" },
  { value: "shark", label: "Shark" },
  { value: "starlite", label: "Starlite" },
  { value: "zyra", label: "Zyra" },
  { value: "maya", label: "Maya" },
  { value: "yuva", label: "Yuva" },
];

export const THEME_ROLES = [
  { label: "Published", value: "main" },
  { label: "Draft", value: "unpublished" },
  { label: "Trial", value: "demo" },
  { label: "Development", value: "development" },
  { label: "Suspect",value: "suspect" },

];

export const emailOptions = {
  welcome: {
    name: "Welcome Email",
    id: "welcome",
    supportedThemerole: ["main"],
  },

  trial: { name: "Trial email", id: "trial", supportedThemerole: ["demo"] },
};

export const countries = [
  { label: "Afghanistan", value: "Afghanistan", countryCode: "AF" },
  { label: "Albania", value: "Albania", countryCode: "AL" },
  { label: "Algeria", value: "Algeria", countryCode: "DZ" },
  { label: "Andorra", value: "Andorra", countryCode: "AD" },
  { label: "Angola", value: "Angola", countryCode: "AO" },
  { label: "Anguilla", value: "Anguilla", countryCode: "AI" },
  {
    label: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
    countryCode: "AG",
  },
  { label: "Argentina", value: "Argentina", countryCode: "AR" },
  { label: "Armenia", value: "Armenia", countryCode: "AM" },
  { label: "Australia", value: "Australia", countryCode: "AU" },
  { label: "Austria", value: "Austria", countryCode: "AT" },
  { label: "Azerbaijan", value: "Azerbaijan", countryCode: "AZ" },
  { label: "Bahamas", value: "Bahamas", countryCode: "BS" },
  { label: "Bahrain", value: "Bahrain", countryCode: "BH" },
  { label: "Bangladesh", value: "Bangladesh", countryCode: "BD" },
  { label: "Barbados", value: "Barbados", countryCode: "BB" },
  { label: "Belarus", value: "Belarus", countryCode: "BY" },
  { label: "Belgium", value: "Belgium", countryCode: "BE" },
  { label: "Belize", value: "Belize", countryCode: "BZ" },
  { label: "Benin", value: "Benin", countryCode: "BJ" },
  { label: "Bhutan", value: "Bhutan", countryCode: "BT" },
  { label: "Bolivia", value: "Bolivia", countryCode: "BO" },
  {
    label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
    countryCode: "BA",
  },
  { label: "Botswana", value: "Botswana", countryCode: "BW" },
  { label: "Brazil", value: "Brazil", countryCode: "BR" },
  { label: "Brunei", value: "Brunei", countryCode: "BN" },
  { label: "Bulgaria", value: "Bulgaria", countryCode: "BG" },
  { label: "Burkina Faso", value: "Burkina Faso", countryCode: "BF" },
  { label: "Burundi", value: "Burundi", countryCode: "BI" },
  { label: "Cabo Verde", value: "Cabo Verde", countryCode: "CV" },
  { label: "Cambodia", value: "Cambodia", countryCode: "KH" },
  { label: "Cameroon", value: "Cameroon", countryCode: "CM" },
  { label: "Canada", value: "Canada", countryCode: "CA" },
  {
    label: "Central African Republic",
    value: "Central African Republic",
    countryCode: "CF",
  },
  { label: "Chad", value: "Chad", countryCode: "TD" },
  { label: "Chile", value: "Chile", countryCode: "CL" },
  { label: "China", value: "China", countryCode: "CN" },
  { label: "Colombia", value: "Colombia", countryCode: "CO" },
  { label: "Comoros", value: "Comoros", countryCode: "KM" },
  { label: "Costa Rica", value: "Costa Rica", countryCode: "CR" },
  { label: "Croatia", value: "Croatia", countryCode: "HR" },
  { label: "Cyprus", value: "Cyprus", countryCode: "CY" },
  { label: "Czechia", value: "Czechia", countryCode: "CZ" },
  { label: "Denmark", value: "Denmark", countryCode: "DK" },
  { label: "Djibouti", value: "Djibouti", countryCode: "DJ" },
  { label: "Dominica", value: "Dominica", countryCode: "DM" },
  {
    label: "Dominican Republic",
    value: "Dominican Republic",
    countryCode: "DO",
  },
  { label: "Ecuador", value: "Ecuador", countryCode: "EC" },
  { label: "Egypt", value: "Egypt", countryCode: "EG" },
  { label: "El Salvador", value: "El Salvador", countryCode: "SV" },
  { label: "Equatorial Guinea", value: "Equatorial Guinea", countryCode: "GQ" },
  { label: "Eritrea", value: "Eritrea", countryCode: "ER" },
  { label: "Estonia", value: "Estonia", countryCode: "EE" },
  { label: "Eswatini", value: "Eswatini", countryCode: "SZ" },
  { label: "Ethiopia", value: "Ethiopia", countryCode: "ET" },
  { label: "Fiji", value: "Fiji", countryCode: "FJ" },
  { label: "Finland", value: "Finland", countryCode: "FI" },
  { label: "France", value: "France", countryCode: "FR" },
  { label: "Gabon", value: "Gabon", countryCode: "GA" },
  { label: "Gambia", value: "Gambia", countryCode: "GM" },
  { label: "Georgia", value: "Georgia", countryCode: "GE" },
  { label: "Germany", value: "Germany", countryCode: "DE" },
  { label: "Ghana", value: "Ghana", countryCode: "GH" },
  { label: "Gibraltar", value: "Gibraltar", countryCode: "GI" },
  { label: "Greece", value: "Greece", countryCode: "GR" },
  { label: "Grenada", value: "Grenada", countryCode: "GD" },
  { label: "Guatemala", value: "Guatemala", countryCode: "GT" },
  { label: "Guinea", value: "Guinea", countryCode: "GN" },
  { label: "Guinea-Bissau", value: "Guinea-Bissau", countryCode: "GW" },
  { label: "Guyana", value: "Guyana", countryCode: "GY" },
  { label: "Haiti", value: "Haiti", countryCode: "HT" },
  { label: "Honduras", value: "Honduras", countryCode: "HN" },
  { label: "Hong Kong SAR", value: "Hong Kong SAR", countryCode: "HK" },
  { label: "Hungary", value: "Hungary", countryCode: "HU" },
  { label: "Iceland", value: "Iceland", countryCode: "IS" },
  { label: "India", value: "India", countryCode: "IN" },
  { label: "Indonesia", value: "Indonesia", countryCode: "ID" },
  { label: "Iraq", value: "Iraq", countryCode: "IQ" },
  { label: "Ireland", value: "Ireland", countryCode: "IE" },
  { label: "Israel", value: "Israel", countryCode: "IL" },
  { label: "Italy", value: "Italy", countryCode: "IT" },
  { label: "Jamaica", value: "Jamaica", countryCode: "JM" },
  { label: "Japan", value: "Japan", countryCode: "JP" },
  { label: "Jordan", value: "Jordan", countryCode: "JO" },
  { label: "Kazakhstan", value: "Kazakhstan", countryCode: "KZ" },
  { label: "Kenya", value: "Kenya", countryCode: "KE" },
  { label: "Kiribati", value: "Kiribati", countryCode: "KI" },
  { label: "Kosovo", value: "Kosovo", countryCode: "XK" },
  { label: "Kuwait", value: "Kuwait", countryCode: "KW" },
  { label: "Kyrgyzstan", value: "Kyrgyzstan", countryCode: "KG" },
  { label: "Laos", value: "Laos", countryCode: "LA" },
  { label: "Latvia", value: "Latvia", countryCode: "LV" },
  { label: "Lebanon", value: "Lebanon", countryCode: "LB" },
  { label: "Lesotho", value: "Lesotho", countryCode: "LS" },
  { label: "Liberia", value: "Liberia", countryCode: "LR" },
  { label: "Libya", value: "Libya", countryCode: "LY" },
  { label: "Liechtenstein", value: "Liechtenstein", countryCode: "LI" },
  { label: "Lithuania", value: "Lithuania", countryCode: "LT" },
  { label: "Luxembourg", value: "Luxembourg", countryCode: "LU" },
  { label: "Macao SAR", value: "Macao SAR", countryCode: "MO" },
  { label: "Madagascar", value: "Madagascar", countryCode: "MG" },
  { label: "Malawi", value: "Malawi", countryCode: "MW" },
  { label: "Malaysia", value: "Malaysia", countryCode: "MY" },
  { label: "Maldives", value: "Maldives", countryCode: "MV" },
  { label: "Mali", value: "Mali", countryCode: "ML" },
  { label: "Malta", value: "Malta", countryCode: "MT" },
  { label: "Marshall Islands", value: "Marshall Islands", countryCode: "MH" },
  { label: "Martinique", value: "Martinique", countryCode: "MQ" },
  { label: "Mauritania", value: "Mauritania", countryCode: "MR" },
  { label: "Mauritius", value: "Mauritius", countryCode: "MU" },
  { label: "Mexico", value: "Mexico", countryCode: "MX" },
  { label: "Micronesia", value: "Micronesia", countryCode: "FM" },
  { label: "Moldova", value: "Moldova", countryCode: "MD" },
  { label: "Monaco", value: "Monaco", countryCode: "MC" },
  { label: "Mongolia", value: "Mongolia", countryCode: "MN" },
  { label: "Montenegro", value: "Montenegro", countryCode: "ME" },
  { label: "Morocco", value: "Morocco", countryCode: "MA" },
  { label: "Mozambique", value: "Mozambique", countryCode: "MZ" },
  { label: "Myanmar", value: "Myanmar", countryCode: "MM" },
  { label: "Namibia", value: "Namibia", countryCode: "NA" },
  { label: "Nauru", value: "Nauru", countryCode: "NR" },
  { label: "Nepal", value: "Nepal", countryCode: "NP" },
  { label: "Netherlands", value: "Netherlands", countryCode: "NL" },
  { label: "New Zealand", value: "New Zealand", countryCode: "NZ" },
  { label: "Nicaragua", value: "Nicaragua", countryCode: "NI" },
  { label: "Niger", value: "Niger", countryCode: "NE" },
  { label: "Nigeria", value: "Nigeria", countryCode: "NG" },
  { label: "North Macedonia", value: "North Macedonia", countryCode: "MK" },
  { label: "Norway", value: "Norway", countryCode: "NO" },
  { label: "Oman", value: "Oman", countryCode: "OM" },
  { label: "Pakistan", value: "Pakistan", countryCode: "PK" },
  { label: "Palau", value: "Palau", countryCode: "PW" },
  { label: "Panama", value: "Panama", countryCode: "PA" },
  { label: "Papua New Guinea", value: "Papua New Guinea", countryCode: "PG" },
  { label: "Paraguay", value: "Paraguay", countryCode: "PY" },
  { label: "Peru", value: "Peru", countryCode: "PE" },
  { label: "Philippines", value: "Philippines", countryCode: "PH" },
  { label: "Poland", value: "Poland", countryCode: "PL" },
  { label: "Portugal", value: "Portugal", countryCode: "PT" },
  { label: "Puerto Rico", value: "Puerto Rico", countryCode: "PR" },
  { label: "Qatar", value: "Qatar", countryCode: "QA" },
  { label: "Romania", value: "Romania", countryCode: "RO" },
  { label: "Rwanda", value: "Rwanda", countryCode: "RW" },
  {
    label: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
    countryCode: "KN",
  },
  { label: "Saint Lucia", value: "Saint Lucia", countryCode: "LC" },
  {
    label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
    countryCode: "VC",
  },
  { label: "Samoa", value: "Samoa", countryCode: "WS" },
  { label: "San Marino", value: "San Marino", countryCode: "SM" },
  {
    label: "Sao Tome and Principe",
    value: "Sao Tome and Principe",
    countryCode: "ST",
  },
  { label: "Saudi Arabia", value: "Saudi Arabia", countryCode: "SA" },
  { label: "Senegal", value: "Senegal", countryCode: "SN" },
  { label: "Serbia", value: "Serbia", countryCode: "RS" },
  { label: "Seychelles", value: "Seychelles", countryCode: "SC" },
  { label: "Sierra Leone", value: "Sierra Leone", countryCode: "SL" },
  { label: "Singapore", value: "Singapore", countryCode: "SG" },
  { label: "Slovakia", value: "Slovakia", countryCode: "SK" },
  { label: "Slovenia", value: "Slovenia", countryCode: "SI" },
  { label: "Solomon Islands", value: "Solomon Islands", countryCode: "SB" },
  { label: "Somalia", value: "Somalia", countryCode: "SO" },
  { label: "South Africa", value: "South Africa", countryCode: "ZA" },
  { label: "South Korea", value: "South Korea", countryCode: "KR" },
  { label: "South Sudan", value: "South Sudan", countryCode: "SS" },
  { label: "Spain", value: "Spain", countryCode: "ES" },
  { label: "Sri Lanka", value: "Sri Lanka", countryCode: "LK" },
  { label: "Sudan", value: "Sudan", countryCode: "SD" },
  { label: "Suriname", value: "Suriname", countryCode: "SR" },
  { label: "Sweden", value: "Sweden", countryCode: "SE" },
  { label: "Switzerland", value: "Switzerland", countryCode: "CH" },
  { label: "Taiwan", value: "Taiwan", countryCode: "TW" },
  { label: "Tajikistan", value: "Tajikistan", countryCode: "TJ" },
  { label: "Tanzania", value: "Tanzania", countryCode: "TZ" },
  { label: "Thailand", value: "Thailand", countryCode: "TH" },
  { label: "Timor-Leste", value: "Timor-Leste", countryCode: "TL" },
  { label: "Togo", value: "Togo", countryCode: "TG" },
  { label: "Tonga", value: "Tonga", countryCode: "TO" },
  {
    label: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
    countryCode: "TT",
  },
  { label: "Tunisia", value: "Tunisia", countryCode: "TN" },
  { label: "Turkey", value: "Turkey", countryCode: "TR" },
  { label: "Turkmenistan", value: "Turkmenistan", countryCode: "TM" },
  { label: "Tuvalu", value: "Tuvalu", countryCode: "TV" },
  { label: "Uganda", value: "Uganda", countryCode: "UG" },
  {
    label: "United Arab Emirates",
    value: "United Arab Emirates",
    countryCode: "AE",
  },
  { label: "United Kingdom", value: "United Kingdom", countryCode: "GB" },
  { label: "United States", value: "United States", countryCode: "US" },

  { label: "Uruguay", value: "Uruguay", countryCode: "UY" },
  { label: "Uzbekistan", value: "Uzbekistan", countryCode: "UZ" },
  { label: "Vanuatu", value: "Vanuatu", countryCode: "VU" },
  { label: "Vatican City", value: "Vatican City", countryCode: "VA" },
  { label: "Venezuela", value: "Venezuela", countryCode: "VE" },
  { label: "Vietnam", value: "Vietnam", countryCode: "VN" },
  { label: "Yemen", value: "Yemen", countryCode: "YE" },
  { label: "Zambia", value: "Zambia", countryCode: "ZM" },
  { label: "Zimbabwe", value: "Zimbabwe", countryCode: "ZW" },
];

export const tableHeaders = [
  "Store Url",
  "Unsubscribed",
  "Name",
  "Version",
  "Status",
  "Email",
  "Region",
  "Created At",
  "Action",
  // "Email Status",
];

export const defaultemailTemplates = {
  trial: {
    id: "trial",
    name: "Trial Email",
    type: "default",
    subject: "Your {{THEME_NAME}} trial is waiting – Ready to publish?",
    body: {
      html: `<h4 > Your {{THEME_NAME}} Trial Is Still Active </h4>
          <p> Hi <strong>{{MERCHANT_NAME}}</strong>,</p>
          <p>  We noticed you’ve installed<strong>{{THEME_NAME}}</strong> but haven’t published it yet. Your trial is the perfect chance to explore the theme’s full potential and see how it can transform your store’s look and feel. </p>
          <p style=" font-weight:bold;">Here are some quick ways to make the most of your trial:</p>
          <p>Customize colors, fonts, and layouts to match your brand</p>
          <p>Preview your store on both mobile and desktop</p>
          <p>Test built-in features like product sections, sliders, and banners</p>
          <p> Need help? Our team is here to guide you with tips, setup assistance, and design suggestions.</p>
          <p>     <a href="{{SUPPORT_LINK}}" target="_blank">Contact our support team</a> or visit your  <a href="{{THEME_CUSTOMIZATION_URL}}" target="_blank">theme setting</a> to start customizing. </p>
          <p> Best regards,</p>
          <p><strong>Shine Dezign Infonet</strong> </p> `,
      bgColor: "#ffffff",
      textColor: "#000000",
    },
    supportedThemerole: ["main", "demo", "unpublished", "development"],
  },

  welcome: {
    id: "welcome",
    name: "Welcome Email",
    type: "default",
    subject: "How's Your Digital Setup Going?",
    body: {
    html: `<h4 >Getting Started with {{THEME_NAME}}</h4>
    <p > Hello <strong>{{MERCHANT_NAME}}</strong>,</p>
    <p >It’s been a few days since you installed <strong>{{THEME_NAME}}</strong>.By now, you’ve probably explored a few features and started customizing your store. We’re here to help if you need guidance, even during the trial.</p>
    <p >Whether you want to fine-tune your design, add new features, or fix any issues,simply reply to this email and we’ll assist you promptly.</p>
    <p > Prefer to explore on your own?<a href="{{DOCS_LINK}}" target="_blank">Read the Docs</a>.We usually respond within an hour.</p>
    <p > Best regards,</p>
    <p >  <strong>Shine Dezign Infonet</strong></p>
    <p > <a href="{{STORE_URL}}" target="_blank">Go to Store</a></p>`,
      bgColor: "#ffffff",
      textColor: "#252524",
    },
    supportedThemerole: ["main", "demo", "unpublished", "development"],
  },
};
